export default class ShowZonesControl {
  constructor(props) {
    this.terminalId = props.terminalId;
    this.id = "showZonesCustomControl";
    this.onZoneClicked = props.onZoneClicked;
    this.zipZoneSource = "zipZoneMapping";
    this.zipZoneLayer = "US_Zones";
    this.geoJson = props.geoJson;
  }

  updateProps = ({ terminalId, geoJson }) => {
    this.terminalId = terminalId;
    this.geoJson = geoJson;
    this._map.on("moveend", this.onMoveEnd); 
  }

  onMoveEnd = () => {
      this.hideLayer(); // Perform hide layer & update sourceafter any pending animation else moving map animation gets blocked
      this.updateSource();
      this._map.off("moveend", this.onMoveEnd);
  }

  hideLayer = () => {
    const layer = this._map.getLayer(this.zipZoneLayer);
    if (layer && layer.visibility === "visible") {
      this._map.setLayoutProperty(this.zipZoneLayer, "visibility", "none");
    }
  }

  onClick = (event) => {
    if (this.onZoneClicked && event.features[0].properties) {
      this.onZoneClicked({
        data: event.features[0].properties,
        position: event.lngLat,
      });
    }
  };
  styleCursor = () => {
    this._map.getCanvas().style.cursor = "pointer";
  };
  removeCursor = () => {
    this._map.getCanvas().style.cursor = "";
  };

  removeZipZoneLayer = () => {
    if(this._map.getLayer(this.zipZoneLayer)){
      this._map.removeLayer(this.zipZoneLayer)
    }
    if(this._map.getSource(this.zipZoneSource)){
      this._map.removeSource(this.zipZoneSource)
    }
  };

  updateSource = () => {
    const source = this._map.getSource(this.zipZoneSource);
    if(!this.geoJson){
      console.warn("Zipzone geojson not found for terminal ", this.terminalId);
      return;
    }
    if(source){
      source.setData(this.geoJson);
    } else {
      const geoJsonData = {
        type: "geojson",
        data: this.geoJson
      };
      this._map.addSource(this.zipZoneSource, geoJsonData);
    }
  }

  onMapStyleLoaded = () => {
    this.updateSource();
    // Add a layer to draw circles for each point in the data source
    this._map.addLayer({
      id: this.zipZoneLayer,
      type: "fill",
      layout: { visibility: "none" },
      source: this.zipZoneSource,
      paint: {
        "fill-color": [
          "case",
          ["match", ["get", "AREA"], "", false, true],
          ["get", "COLOR"],
          ["get", "COLOR"],
        ],
        "fill-opacity": 0.2,
      },
    });
  };

  onAdd(map) {
    this._map = map;
    this._map?.on("load", this.onMapStyleLoaded);
    this._container = document.createElement("div");
    this._container.className =
      "trimblemaps-ctrl trimblemaps-ctrl-group showZones";

    const control = document.createElement("button");
    control.className = "trimblemaps-ctrl-icon icon-showZones";
    control.title = "Show/Hide Zones";
    control.textContent = "";
    control.ariaLabel = "Show/Hide Zones";
    control.addEventListener("click", () => {
      if (!this._map.getLayer(this.zipZoneLayer)) {
        this.onMapStyleLoaded();
      }

      const zonesLayer = this._map.getLayer(this.zipZoneLayer);
      if (zonesLayer) {
       
        this._map.setFilter(zonesLayer.id, ['==', 'TERM', this.terminalId])
        this._map.setLayoutProperty(zonesLayer.id, "visibility", zonesLayer.visibility==="visible"?"none":"visible");

        if (zonesLayer.visibility === "visible") {
          map.on("click", this.zipZoneLayer, this.onClick);
          map.on("mouseenter", this.zipZoneLayer, this.styleCursor);
          map.on("mouseleave", this.zipZoneLayer, this.removeCursor);
        } else {
          map.off("click", this.zipZoneLayer, this.onClick);
          map.off("mouseenter", this.zipZoneLayer, this.styleCursor);
          map.off("mouseleave", this.zipZoneLayer, this.removeCursor);
        }
      }
    });
    this._container.append(control);
    return this._container;
  }
  onRemove() {
    this.removeZipZoneLayer();
    this._container.parentNode.removeChild(this._container);
    this._map.off("click", "US_Zones", this.onClick);
    this._map.off("mouseenter", "US_Zones", this.styleCursor);
    this._map.off("mouseleave", "US_Zones", this.removeCursor);
    this._map?.off("load", this.onMapStyleLoaded);
    this._map = undefined;
  }
}
